import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getAccountsBasedOnSite(
  oauthTokenHeader: string,
  queryId: string,
  site_shared_uid: string,
  account_traffic_source_shared_uid: string | any,
  account_isactive: number | any,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?website_shared_uid=${site_shared_uid}&account_traffic_source_shared_uid=${account_traffic_source_shared_uid}&account_isactive=${account_isactive}`,
    oauthTokenHeader,
  );
}

function removeNegativeTerms(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/negative_terms/remove`,
    data,
    oauthTokenHeader,
  );
}

///------------------Scopes Tab Endpoints------------------///

function getAllScopes(
  oauthTokenHeader: string,
  website_shared_uid: string,
  account_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/advertising_management/methodology_optimization/campaign_to_scope/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}`,
    oauthTokenHeader,
  );
}

function getCampaignsWithoutScope(
  oauthTokenHeader: string,
  queryId: string,
  website_shared_uid: string,
  account_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}`,
    oauthTokenHeader,
  );
}

function getNegativeDefinitionBothListAndAdgroup(
  oauthTokenHeader: string,
  queryId: string,
  website_shared_uid: string,
  account_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}`,
    oauthTokenHeader,
  );
}

function getNegativeDefinitionInCampaign(
  oauthTokenHeader: string,
  queryId: string,
  website_shared_uid: string,
  account_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}`,
    oauthTokenHeader,
  );
}

function createNewScope(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/advertising_management/methodology_optimization/campaign_to_scope/scope/`,
    data,
    oauthTokenHeader,
  );
}

function editScope(oauthTokenHeader: string, data: any, scope_shared_uid: any) {
  return fetchWrapper.patch(
    `${apiUrl}/advertising_management/methodology_optimization/campaign_to_scope/scope/${scope_shared_uid}/`,
    data,
    oauthTokenHeader,
  );
}

function linkBetweenCampaignToScope(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/advertising_management/methodology_optimization/campaign_to_scope/campaign_to_scope/`,
    data,
    oauthTokenHeader,
  );
}

function unlinkCampaigsFromScope(oauthTokenHeader: string, data: any) {
  return fetchWrapper.patch(
    `${apiUrl}/advertising_management/methodology_optimization/campaign_to_scope/unlink/`,
    data,
    oauthTokenHeader,
  );
}

//-------------------------------Search Term Tab Endpoints----------------------//

function getSTPerformanceUnclassified(
  oauthTokenHeader: string,
  queryId: string,
  website_shared_uid: string,
  account_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}`,
    oauthTokenHeader,
  );
}

function createPositiveLinks(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/positive_links/create`,
    data,
    oauthTokenHeader,
  );
}

//Add negative terms to Adgroup
function addNegativeTermsToAdgroup(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/negative_terms/add`,
    data,
    oauthTokenHeader,
  );
}

//Estimate Missing Cross Negatives
function getExclusiveMissingCrossNegatives(
  oauthTokenHeader: string,
  queryId: string,
  website_shared_uid: string,
  account_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}`,
    oauthTokenHeader,
  );
}

//Get Contradicting ST Definitions
function getContradictingSTDefinitions(
  oauthTokenHeader: string,
  queryId: string,
  website_shared_uid: string,
  account_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}`,
    oauthTokenHeader,
  );
}

function getSTOperationAIRecommendation(
  oauthTokenHeader: string,
  queryId: string,
  website_shared_uid: string,
  account_shared_uid: string,
  scope_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}&scope_shared_uid=${scope_shared_uid}`,
    oauthTokenHeader,
  );
}
//Get Identical to Exact Keyword
function getIdenticalToExactKeyword(
  oauthTokenHeader: string,
  queryId: string,
  website_shared_uid: string,
  account_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}`,
    oauthTokenHeader,
  );
}

//Get Captured By Multiple Keywords
function getCapturedByMultipleKeywords(
  oauthTokenHeader: string,
  queryId: string,
  website_shared_uid: string,
  account_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}`,
    oauthTokenHeader,
  );
}

function getPositiveOrNegetiveST(
  oauthTokenHeader: string,
  queryId: string,
  keyword_shared_uid: string,
  website_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?keyword_shared_uid=${keyword_shared_uid}&website_shared_uid=${website_shared_uid}`,
    oauthTokenHeader,
  );
}

//Activate or Deactivate Positive Links
function activeOrInactivePositiveLinks(data: any, oauthTokenHeader: any) {
  return fetchWrapper.patch(
    `${apiUrl}/positive_links/toggle_status`,
    data,
    oauthTokenHeader,
  );
}

function removeNegativeTermsAi(
  oauthTokenHeader: string,
  data: any,
  keyword_shared_uid: string,
) {
  return fetchWrapper.post(
    `${apiUrl}/positive_links/recommendations/${keyword_shared_uid}/`,
    data,
    oauthTokenHeader,
  );
}

function updateRecommendation(
  oauthTokenHeader: string,
  data: any,
  shared_uid: string,
) {
  return fetchWrapper.patch(
    `${apiUrl}/recommendations/${shared_uid}/`,
    data,
    oauthTokenHeader,
  );
}

function getAllExactST(
  oauthTokenHeader: string,
  queryId: string,
  ad_shared_uid: string,
  website_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?ad_shared_uid=${ad_shared_uid}&website_shared_uid=${website_shared_uid}`,
    oauthTokenHeader,
  );
}

function getAllSTLevel(
  oauthTokenHeader: string,
  queryId: string,
  website_shared_uid: string,
  account_shared_uid: string,
  scope_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?website_shared_uid=${website_shared_uid}&account_shared_uid=${account_shared_uid}&scope_shared_uid=${scope_shared_uid}`,
    oauthTokenHeader,
  );
}

function getKeywordDetails(
  queryId: string,
  oauthTokenHeader: string,
  search_term: string,
  search_term_match_type: string,
  scope_shared_uid: string,
  website_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?search_term=${search_term}&search_term_match_type=${search_term_match_type}&scope_shared_uid=${scope_shared_uid}&website_shared_uid=${website_shared_uid}`,
    oauthTokenHeader,
  );
}

export const stOperationService = {
  getAccountsBasedOnSite,
  getAllScopes,
  getCampaignsWithoutScope,
  getNegativeDefinitionBothListAndAdgroup,
  getNegativeDefinitionInCampaign,
  createNewScope,
  linkBetweenCampaignToScope,
  removeNegativeTerms,
  editScope,
  unlinkCampaigsFromScope,
  getSTPerformanceUnclassified,
  createPositiveLinks,
  addNegativeTermsToAdgroup,
  getExclusiveMissingCrossNegatives,
  getContradictingSTDefinitions,
  getIdenticalToExactKeyword,
  getCapturedByMultipleKeywords,
  activeOrInactivePositiveLinks,
  getSTOperationAIRecommendation,
  getPositiveOrNegetiveST,
  removeNegativeTermsAi,
  updateRecommendation,
  getAllExactST,
  getAllSTLevel,
  getKeywordDetails,
};
